"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductCategoriesTrads = void 0;
exports.EProductCategoriesTrads = {
    activity_logistic: "Activité/Logistique",
    diversified: "Diversifiée",
    health: "Santé et éducation",
    office: "Bureaux",
    regional_diversified: "Diversifiée régionale",
    residential: "Résidentielle",
    retail: "Commerces",
    tourism: "Tourisme et loisirs",
    forest: "Forêt",
    vineyard: "Vigne",
    usufruct_scpi: "Usufruit de SCPI",
    life_annuity: "Viager",
    fip: "FIP",
    fcpi: "FCPI",
    fpci: "FPCI",
};
